import OnlineAttendeeAllocators from './OnlineAttendeeAllocators'

export default OnlineAttendeeAllocators
